module.exports = __webpack_public_path__ + "img/sari-event-mobile.867ce2b.webp";